import React, { useState } from "react";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "How does Vyango ride-sharing work?",
      answer:
        "Vyango connects drivers and passengers going to the same destination, helping both save travel cost.",
    },
    {
      question: "Is Vyango free to use?",
      answer:
        "Yes! Vyango is completely free for passengers and drivers. No commission is taken.",
    },
    {
      question: "How do I contact a driver?",
      answer:
        "Once you join a ride, you can chat, voice call, or video call with the driver directly through the app.",
    },
    {
      question: "Is my data safe?",
      answer:
        "Your chats and calls are encrypted. Vyango never shares your personal info with anyone.",
    },
    {
      question: "Can I cancel my ride?",
      answer:
        "Yes, you can cancel the ride anytime before it starts from the ride details page.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      {/* ---- INLINE FAQ CSS ---- */}
      <style>{`
        .faq-container {
          width: 80%;
          max-width: 900px;
          margin: 60px auto;
          font-family: "Inter", sans-serif;
        }

        .faq-title {
          text-align: center;
          font-size: 32px;
          margin-bottom: 25px;
          font-weight: 700;
          color: #222;
        }

        .faq-item {
          background: #fff;
          margin-bottom: 12px;
          padding: 18px 22px;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .faq-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
        }

        .faq-question {
          font-size: 18px;
          font-weight: 600;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #333;
        }

        .faq-icon {
          font-size: 26px;
          font-weight: 600;
          color: #007bff;
        }

        .faq-answer {
          max-height: 0;
          overflow: hidden;
          font-size: 16px;
          color: #555;
          transition: all 0.3s ease;
          margin-top: 8px;
          line-height: 1.6;
        }

        .faq-item.active .faq-answer {
          max-height: 300px;
          padding-top: 10px;
        }
      `}</style>

      {/* ---- FAQ UI ---- */}
      <div className="faq-container">
        <h2 className="faq-title">Frequently Asked Questions</h2>

        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              {faq.question}
              <span className="faq-icon">{activeIndex === index ? "−" : "+"}</span>
            </div>

            <div className="faq-answer">{faq.answer}</div>
          </div>
        ))}
      </div>
    </>
  );
}